import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  TwoFactorConfigurationService,
  type Wealthlane_Shared_Hosting_Dtos_GenericApiResponse,
} from '@wealthlane/api-services/wealthlane-identity-service';
import { Wealthlane_Dtos_TwoFactor_SetTwoFactorAssignmentDto } from '@wealthlane/api-services/wealthlane-identity-service';

const usePostTwoFactorConfiguration = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  onClose?: () => void
): UseMutationResult<
  Wealthlane_Shared_Hosting_Dtos_GenericApiResponse | undefined,
  unknown,
  Array<Wealthlane_Dtos_TwoFactor_SetTwoFactorAssignmentDto>,
  unknown
> => {
  const queryClient = useQueryClient();

  return useMutation(
    async (body: Array<Wealthlane_Dtos_TwoFactor_SetTwoFactorAssignmentDto>) => {
      return await handleRequest(
        TwoFactorConfigurationService.postApiIdentityApiTwoFactorConfiguration(body)
      );
    },
    {
      onSuccess: (response: any) => {
        if (response != null) {
          toast.success(
            <ToastComponent label='Success' message={response?.message ?? 'Two-factor authentication settings have been saved.'} />
          );
          void queryClient.invalidateQueries('getTwoFactorConfiguration');
          void queryClient.invalidateQueries('getSetOption');
          onClose?.();
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostTwoFactorConfiguration;
